import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=6485e2a5&scoped=true&class=true&"
import script from "./GenericTable.vue?vue&type=script&lang=js&"
export * from "./GenericTable.vue?vue&type=script&lang=js&"
import style0 from "./GenericTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GenericTable.vue?vue&type=style&index=1&id=6485e2a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485e2a5",
  null
  
)

export default component.exports